module.exports = __webpack_public_path__ + "img/visa.387219f.svg";